import { render, staticRenderFns } from "./FormConfirmation.vue?vue&type=template&id=5c3f770d&"
import script from "./FormConfirmation.vue?vue&type=script&lang=js&"
export * from "./FormConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./FormConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports